import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	reportToAtlassianDefault: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	reportToAtlassianDefault: {
		id: 'atlassian-intelligence.prompt-response.report-to-atlassian-button.report-to-atlassian-default',
		defaultMessage: 'Report to Atlassian',
		description: 'Default aria-label for Report to Atlassian feedback button',
	},
});
export default messages;
